import axios, { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import { AccountData } from '@Types'
import { getAppConfigSetting } from '../utils'
import { ACCOUNTS_API } from './constants'
import queryKeys from './queryKeys'

export function useAccountLookup(accountNumber: string) {
  const getAccountsApi = `${getAppConfigSetting('apiUrl')}${ACCOUNTS_API}`

  const getAccountDetailsUrl = (accountNumber: string) => `${getAccountsApi}/${accountNumber}`

  const getAccountDetails = async () => {
    const { data } = await axios.get(getAccountDetailsUrl(accountNumber), {
      withCredentials: true
    })
    return data
  }
  return useQuery<AccountData, AxiosError>([queryKeys.accountLookup, accountNumber], getAccountDetails, {
    enabled: false
  })
}
